import { Component } from '@angular/core';
import { HeaderComponent } from "../shared/header/header.component";
import { LeftNavComponent } from "../shared/left-nav/left-nav.component";
import { FooterComponent } from "../shared/footer/footer.component";
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-home',
  imports: [HeaderComponent, LeftNavComponent, FooterComponent, RouterModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
 
  
}
